export enum StatementFormats {
    csv = 'CSV',
    xlsx = 'XLSX'
}

export default [
    StatementFormats.csv,
    StatementFormats.xlsx
]
